/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-mate.chat-error-banner.description': '채팅 기록은 최대 30일간 저장됩니다.',
  'ai-mate.chat-error-banner.title': '새 채팅 시작',
  'ai-mate.chat-error.description': '<btn>채팅을 다시 로드</btn>해 보세요.',
  'ai-mate.chat-error.rate-limited-description': '최대 요청 수에 도달했습니다. 나중에 다시 시도하세요.',
  'ai-mate.chat-error.rate-limited-title': '요청이 너무 많음',
  'ai-mate.chat-error.rovo-inactive-description':
    '귀하의 사이트에서 Rovo가 활성화되지 않은 것 같습니다. <link>Rovo 설정</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo가 비활성화됨',
  'ai-mate.chat-error.title': '알 수 없는 문제가 발생했습니다',
  'conversation-assistant-button.label': '채팅',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'AI에게 질문',
  'highlight-actions.rovo-chat-explain-option.text': '설명',
  'highlight-actions.rovo-chat-explain-prompt': '설명: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': '채팅 추천',
  'highlight-actions.rovo-chat-open-chat.tooltip': '채팅 열기',
  'highlight-actions.rovo-chat-summarize-option.text': '요약',
  'highlight-actions.rovo-chat-summarize-prompt': '요약: {selectedText}',
  'highlight-actions.rovo-chat.button-text': '채팅',
  'horizontal-scroll-container.scroll-left': '왼쪽으로 스크롤',
  'horizontal-scroll-container.scroll-right': '오른쪽으로 스크롤',
};
